var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1267_43)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1267_43",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 125,
    width: 475,
    height: 475,
    rx: 60
  })), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 125,
    width: 475,
    height: 475,
    rx: 60,
    stroke: "#9B9B9B",
    strokeWidth: 160,
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1_1267_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 80H80V157.5H0V60C0 26.8629 26.8629 1.69118e-06 60 0H240V80Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165,
    y1: 40,
    x2: 435,
    y2: 40,
    stroke: "#9B9B9B",
    strokeWidth: 80,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362,
    y1: 442,
    x2: 362,
    y2: 282,
    stroke: "#9B9B9B",
    strokeWidth: 60,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282,
    y1: 362,
    x2: 442,
    y2: 362,
    stroke: "#9B9B9B",
    strokeWidth: 60,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 435,
    x2: 40,
    y2: 135,
    stroke: "#9B9B9B",
    strokeWidth: 80,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1267_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDuplicate);
export default __webpack_public_path__ + "static/media/ico_duplicate.adc45d32afd44a3d60f198a3dae7eb88.svg";
export { ForwardRef as ReactComponent };